export default __webpack_public_path__ + "static/media/nervous-oopsie-poopsie.07cb72b9.gif";